import React from "react"
import BackgroundImage from "../components/background-images"
import SEO from "../components/seo"
import { useTranslation } from "react-i18next"
import Footer from "../components/footer"
import Header from "../components/header"

const imprint = () => {
  const { t } = useTranslation()

  return (
    <BackgroundImage>
      <SEO title="Imprint" />
      <div className="container">
        <h2>Impressum / Haftung</h2>
        <h4>Serviceanbieter</h4>
        <p>
          FOLO GmbH <br />
          Rotlintstraße 45
          <br />
          60316 Frankfurt
          <br />
          Deutschland
        </p>
        <h4>Inhaber</h4>
        <p>
          FOLO GmbH <br />
          Rotlintstraße 45
          <br />
          60316 Frankfurt
          <br />
          Deutschland <br />
          Telefon: <a href="tel:+49 15206318626">+49 15206318626</a> <br />
          E-mail: <a href="mailto:hello@foloaround.com">
            hello@foloaround.com
          </a>{" "}
          <br />
          <strong>Geschäftsführerin: Tabea Arnold</strong>
        </p>
        <h4>Registrierung</h4>
        <p>
          Registergericht: Amtsgericht Frankfurt, HRB 118859
          <br />
          Steuernummer: 04523343109
        </p>
        <h4>Urheberrechtsschutz</h4>
        <p>
          Diese Website und deren Inhalte sind urheberrechtlich geschützt. Sie
          dürfen für den persönlichen Gebrauch vervielfältigt werden. Ohne die
          Zustimmung der verantwortlichen Person dürfen keine Änderungen
          vorgenommen, Kopien verbreitet und ganz oder teilweise für die
          öffentliche Wiedergabe verwendet werden.
        </p>
        <h4 className="header4">
          Referenz zur Online-Streitbeilegungsplattform (OS-Plattform)
        </h4>
        <p>
          Wenn Sie Probleme mit unseren Diensten haben und eine Beschwerde
          einreichen möchten, können Sie auf den folgenden Seiten Streitigkeiten
          durch eine unabhängige Streitbeilegungsstelle beilegen. <br />
          <a
            href="https://ec.europa.eu/info/policies/consumers_en"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/info/policies/consumers_en
          </a>
          <br />
          <a
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage
          </a>
        </p>
        <h4>Haftung für Inhalte</h4>
        <p>
          Nach § 7 Abs.1 Telemediengesetz (TMG) sind wir als Diensteanbieter für
          eigene Angaben, die wir zur Nutzung bereithalten, nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Das Telekommunikationsgeheimnis nach § 88 TGM ist zu wahren. Eine
          diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
          einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
          entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </p>
        <h4>Haftung für Links</h4>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Deshalb können wir für diese fremden Inhalte auch
          keine Gewähr übernehmen. Die verlinkten Seiten wurden zum Zeitpunkt
          der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine
          permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
          Links umgehend entfernen.
        </p>
      </div>
      <Header />
      <Footer />
    </BackgroundImage>
  )
}

export default imprint
